/**
 * Append query parameters safely to an API path.
 * - Handles arrays: `ids: [1, 2]` -> `ids=1&ids=2`
 * - Handles booleans, numbers, and strings.
 * - Ignores undefined, null, and empty string ''.
 * - Safely handles paths that already contain query strings (e.g. `/api/test?tab=all`).
 */
export function withQuery(path: string, query?: object | null): string {
  if (!query || typeof query !== 'object') {
    return path
  }

  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null || value === '') {
      continue
    }

    if (Array.isArray(value)) {
      for (const item of value) {
        if (item !== undefined && item !== null && item !== '') {
          params.append(key, String(item))
        }
      }
    } else if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      params.set(key, String(value))
    }
  }

  const search = params.toString()
  if (!search) {
    return path
  }

  const separator = path.includes('?') ? '&' : '?'
  return `${path}${separator}${search}`
}
